var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lu-vbox',{staticClass:"app-container",attrs:{"lu-flex":""}},[_c('lu-item')],1)}
var staticRenderFns = []

export { render, staticRenderFns }